import { lazy } from 'react';

const LoadableDeleteRoomModal = lazy(
  () => import(/* webpackChunkName: "damz-modals" */ './DeleteRoomModal')
);

export default LoadableDeleteRoomModal;
